import LocalizedStrings from "react-localization";
import { EngLocalizedStrings } from "./english";
import { VnLocalizedStrings } from "./vietnam";
export const strings = new LocalizedStrings({
  vn: VnLocalizedStrings,
  en: EngLocalizedStrings,
});
